// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3cEOf","footer":"ModalCreateQualiphyProcedure_footer__2dy1v","additionData":"ModalCreateQualiphyProcedure_additionData__1mklD"};